import React from 'react'
import '@css/common/BadgeComponent.scss'
import { EventCalendarIconComponent } from '~/common/EventCalendarIconComponent'
import { Maybe } from '~/api/generated/graphql'
import { useClickOnEnter } from './hooks/useClickOnEnter'

interface EventBadgeProps {
  event?: Maybe<{
    title?: Maybe<string>
    hidden?: Maybe<boolean>
    eventStart?: string
    draft?: boolean
  }>
  clickEvent: () => void
  canEdit: boolean
}

const getDraftIndicator = () => {
  return <div className={'draft-indicator'}>DRAFT</div>
}

export const EventBadgeComponent = ({ event, clickEvent }: EventBadgeProps) => {
  const badgeRef = useClickOnEnter<HTMLDivElement>()

  return (
    <div
      className={`event-badge${event?.hidden ? ' deleted' : ''}`}
      title={event?.title || ''}
      onClick={clickEvent}
      tabIndex={0}
      ref={badgeRef}
    >
      <div className="badge-body">
        <EventCalendarIconComponent eventStart={event?.eventStart ?? ''} className={'small-card'} />
        {event?.draft && getDraftIndicator()}
        <div className={'event-info'}>
          <p className={'title'}>{event?.title || ''}</p>
        </div>
      </div>
    </div>
  )
}
